import axios from 'axios';

const qs = require('querystring');

class WebsiteService {
    baseUrl = process.env.VUE_APP_WEBSITE_BASE_URL
    store

    constructor(store) {
        this.store = store;
    }

    getUserInfo() {
        this.getRequest('videochatapi/v1/client').then((response) => {
            var client = response.data;
            if (client) {
                this.store.commit("setClient", client);
            } else {
                this.store.commit("clearClient");
            }
        });
    }

    getCartInfo() {
        this.getRequest('videochatapi/v1/shoppingCart').then((response) => {
            var cart_info = response.data;
            if (cart_info) {
                this.store.commit("setCartInfo", cart_info);
            } else {
                this.store.commit("clearCartInfo");
            }
        });
    }

    getRequest(url, data) {
        return this.sendRequest(url, data, 'get')
    }

    postRequest(url, data) {
        return this.sendRequest(url, data, 'post')
    }

    sendRequest(url, data, requestType) {
        if (requestType == 'get') {
            return axios.get(
                this.baseUrl + url,
                {params: data}
            );
        } else {
            return axios.post(
                this.baseUrl + url,
                qs.stringify(data)
            );
        }
    }
}

export default WebsiteService;